import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthApiService} from '../auth/auth-api.service';

export type ConnectSecretMasked = {masked: string; hasSecret: boolean};

@Injectable({
  providedIn: 'root',
})
export class ConnectSecretsService {
    private readonly api = inject(AuthApiService);

  secretScopeForProvider(providerId: string): string {
    return `providers/${providerId}`;
  }

  secretScopeForConnection(connectionId: string): string {
    return `connections/${connectionId}`;
  }

  getMaskedSecret(scope: string, name: string): Observable<ConnectSecretMasked> {
    const url = `/api/v1/secrets?scope=${encodeURIComponent(scope)}&name=${encodeURIComponent(name)}`;
    return this.api.get<ConnectSecretMasked>(url);
  }

  setSecret(scope: string, name: string, value: string): Observable<void> {
    return this.api.put<void>(`/api/v1/secrets`, {scope, name, value});
  }
}
